import InviteFriendButton from './InviteFriendButton';

export default InviteFriendButton;
